/** Editor chrome only — never on live Stage/Fan or `?preview=true` iframes. */
export function shouldMountScreenElementBoundingBox(opts: {
  editor: boolean;
  preview: boolean;
}): boolean {
  return opts.editor && !opts.preview;
}
